import { render, staticRenderFns } from "./DesarrolloProfesional.vue?vue&type=template&id=395fe06d&scoped=true"
import script from "./DesarrolloProfesional.vue?vue&type=script&lang=js"
export * from "./DesarrolloProfesional.vue?vue&type=script&lang=js"
import style0 from "./DesarrolloProfesional.vue?vue&type=style&index=0&id=395fe06d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395fe06d",
  null
  
)

export default component.exports